import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_@playwright+test@1.58.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/app/src/components/ui/toast.tsx");
